import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-6 mb-4 card sm:p-8"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "การชำระเงิน", -1)
const _hoisted_5 = { class: "flex flex-col p-3 space-y-6 sm:p-6" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4" }
const _hoisted_8 = { class: "flex space-x-4 items-center h-full relative" }
const _hoisted_9 = ["src", "onerror"]
const _hoisted_10 = { class: "flex-1 w-20 flex flex-col text-left gap-1" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm md:text-base clamp-1 text-gray-500"
}
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "text-sm md:text-base clamp-1 text-gray-500" }
const _hoisted_14 = { class: "flex flex-col text-left gap-1" }
const _hoisted_15 = { class: "text-xs clamp-1 md:text-sm text-gray-500 opacity-70" }
const _hoisted_16 = { class: "text-sm md:text-md text-gray-500 font-semibold" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(22141 4199)"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      id: "Rectangle_2086",
      "data-name": "Rectangle 2086",
      width: "24",
      height: "24",
      transform: "translate(-22141 -4199)",
      fill: "#fff",
      opacity: "0"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Icon_awesome-copy",
      "data-name": "Icon awesome-copy",
      d: "M11.438,16.014v1.43a.858.858,0,0,1-.858.858H.858A.858.858,0,0,1,0,17.443V4.289a.858.858,0,0,1,.858-.858H3.432v10.58a2,2,0,0,0,2,2Zm0-12.3V0H5.433a.858.858,0,0,0-.858.858V14.012a.858.858,0,0,0,.858.858h9.723a.858.858,0,0,0,.858-.858V4.575H12.3A.86.86,0,0,1,11.438,3.717Zm4.324-1.109L13.405.251A.858.858,0,0,0,12.8,0h-.217V3.432h3.432V3.215a.858.858,0,0,0-.251-.607Z",
      transform: "translate(-22137.008 -4196.15)",
      fill: "#bababa"
    })
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "fixed flex flex-col w-3/5 gap-4 top-5 right-5 lg:w-2/5 xl:w-1/5" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-center w-12 bg-green-500\"><svg class=\"w-6 h-6 text-white fill-current\" viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z\"></path></svg></div><div class=\"px-4 py-2 -mx-3\"><div class=\"mx-3\"><span class=\"font-semibold text-green-500 dark:text-green-400\">Success</span><p class=\"text-sm text-gray-600 dark:text-gray-200\">Coppy Success</p></div></div>", 2)
const _hoisted_23 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (
      (_ctx.data && !_ctx.data.shippingConfirmedData) ||
      (_ctx.data!.shippingConfirmedData && !_ctx.data!.shippingConfirmedData.isCOD)
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "bullet_main",
              src: require('@/assets/icon_bullet/payment.svg'),
              alt: ""
            }, null, 8, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapListPaymentAvailableData(
            _ctx.data!.paymentAvailableData
          ), (itemPayment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: itemPayment.name
              }, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(itemPayment.name === "bankDeposit" ? "ธนาคาร" : "เงินสด"), 1),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemPayment.data, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.paymentMethodId,
                      class: "border-2 rounded-md border-gray-100 p-2"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          class: "min-w-10 max-w-10 min-h-10 max-h-10 md:min-w-16 md:max-w-16 md:min-h-16 md:max-h-16 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                          src: 
                    _ctx.envMedia +
                    '/public/' +
                    (item.paymentMethodType !== 'cash'
                      ? item.paymentIconUrl
                      : 'icons/payment/cash.webp')
                  ,
                          onerror: `this.src =
                    '${_ctx.envMedia}/public/icons/web/empty.png'`,
                          alt: ""
                        }, null, 8, _hoisted_9),
                        _createElementVNode("div", _hoisted_10, [
                          (item.paymentMethodType === 'cash')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.paymentAliasName), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.getAttribute(item).bankAccountName
                            ? _ctx.convertBankName(
                                _ctx.getAttribute(item).bankAccountName
                            )
                            : "") + " " + _toDisplayString(_ctx.getAttribute(item).branchName
                            ? "(" + _ctx.getAttribute(item).branchName + ")"
                            : ""), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.getAttribute(item).accountName), 1),
                                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.paymentNumber(_ctx.getAttribute(item).accountNo)), 1)
                                ])
                              ], 64))
                        ]),
                        (item.paymentMethodType !== 'cash')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.copyLink(item)),
                              class: "inline-flex w-10 justify-center bg-gray-100 p-2 shadow-md rounded-full cursor-pointer right-0"
                            }, _hoisted_19, 8, _hoisted_17))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogCopyArr, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "z-20 flex w-full max-w-sm overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800"
        }, _hoisted_23))
      }), 128))
    ])
  ], 64))
}